import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapaService } from 'app/services/mapa/mapa.service';
import { TemposRastros } from 'app/interfaces/Rastro';
import { LoadingComponent } from "../../loading/loading.component";
import { MatTooltip } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-dialog-de-rastros',
  standalone: true,
  imports: [CommonModule, LoadingComponent, MatTooltip, TranslocoModule],
  templateUrl: './dialog-de-rastros.component.html',
  styleUrl: './dialog-de-rastros.component.css'
})
export class DialogRastrosComponent implements OnInit {
  @Input() operacaoId!: number;
  public temposRastros: TemposRastros = [];
  public carregandoRastros: boolean = true;
  protected readonly Math = Math;
  public coresRastros: any = {
    plantando: '#0cda28',
    deslocando: '#2D9CDB',
    manobrando: '#FF5B5B'
  }
  constructor(
      private readonly mapaService: MapaService,
    ) { }

  ngOnInit(): void {
    this.buscarRastros();
  }

  public buscarRastros(): void {
    if(this.operacaoId){
      this.carregandoRastros = true;
      this.mapaService.buscarRastroMapa(this.operacaoId).subscribe(
        (tempoRastros) => {
          this.temposRastros = tempoRastros;
          this.carregandoRastros = false;
        }
      )
    }
  }
}
